import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { ArovySubdomainValidationPattern } from './Validation';
import classNames from 'classnames';
import { Button, Form, Input } from 'antd';
import { OidcProviderDeleteButton, OidcProviderHelpArticleLink, OktaIcon } from '.';
import React, { useCallback, useEffect, useRef } from 'react';
export const OktaOidcProviderSetup = (props) => {
    const { oidcConfiguration, onCleared, onDeleted, onUpdated, isErrored, isEnteringNewData } = props;
    const formRef = useRef(null);
    const formStyle = classNames('oidc-provider-setup-form', 'inline-form-with-overhead-labels', { 'oidc-errored-form': isErrored });
    const handleUpdated = useCallback((values) => {
        if (onUpdated && values.clientId && values.oktaDomain && values.subdomain) {
            onUpdated({
                oidcClientId: values.clientId,
                oidcDomain: values.oktaDomain,
                oidcIssuer: values.oktaDomain,
                provider: 'okta',
                subdomain: values.subdomain
            });
        }
    }, [onUpdated]);
    useEffect(() => {
        var _a;
        if (oidcConfiguration) {
            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.resetFields();
        }
    }, [oidcConfiguration]);
    return (React.createElement("div", null,
        React.createElement(OidcProviderHelpArticleLink, { icon: React.createElement(OktaIcon, null), link: ADMIN_DASHBOARD_COPY.OKTA_HELP_ARTICLE_LINK, text: ADMIN_DASHBOARD_COPY.OKTA_HELP_ARTICLE }),
        React.createElement(Form, { className: formStyle, colon: false, initialValues: {
                clientId: oidcConfiguration === null || oidcConfiguration === void 0 ? void 0 : oidcConfiguration.oidcClientId,
                oktaDomain: oidcConfiguration === null || oidcConfiguration === void 0 ? void 0 : oidcConfiguration.oidcDomain,
                subdomain: oidcConfiguration === null || oidcConfiguration === void 0 ? void 0 : oidcConfiguration.subdomain
            }, layout: 'inline', onFinish: handleUpdated, ref: formRef },
            React.createElement(Form.Item, { label: ADMIN_DASHBOARD_COPY.OKTA_DOMAIN, name: 'oktaDomain', rules: [
                    {
                        message: ADMIN_DASHBOARD_COPY.OKTA_DOMAIN_REQUIRED,
                        required: true
                    },
                    {
                        message: ADMIN_DASHBOARD_COPY.OKTA_DOMAIN_INVALID_FORMAT,
                        pattern: /^https:\/\/.+?\.okta\.com$/u
                    }
                ] },
                React.createElement(Input, null)),
            React.createElement(Form.Item, { label: ADMIN_DASHBOARD_COPY.OKTA_CLIENT_ID, name: 'clientId', rules: [
                    {
                        message: ADMIN_DASHBOARD_COPY.OKTA_CLIENT_ID_REQUIRED,
                        required: true
                    }
                ] },
                React.createElement(Input, null)),
            React.createElement(Form.Item, { label: ADMIN_DASHBOARD_COPY.AROVY_SUBDOMAIN, name: 'subdomain', rules: [
                    {
                        message: ADMIN_DASHBOARD_COPY.AROVY_SUBDOMAIN_REQUIRED,
                        required: true
                    },
                    {
                        message: ADMIN_DASHBOARD_COPY.AROVY_SUBDOMAIN_INVALID_FORMAT,
                        pattern: ArovySubdomainValidationPattern
                    }
                ] },
                React.createElement(Input, null)),
            React.createElement(Button, { htmlType: 'submit', type: 'primary' }, ADMIN_DASHBOARD_COPY.SUBMIT),
            React.createElement(OidcProviderDeleteButton, { isEnteringNewData: isEnteringNewData, onCleared: onCleared, onDeleted: onDeleted }))));
};
